import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data";
import { Reveal, Eyebrow, H2 } from "./Typo";

export default function FaqBlock() {
  return (
    <section id="faq" data-testid="faq-section" className="section-pad bg-white">
      <div className="container-hw grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <Eyebrow>FAQ</Eyebrow>
          <H2 className="mt-6">Frequently Asked Questions.</H2>
        </Reveal>
        <div className="lg:col-span-7 lg:col-start-6">
          <Accordion type="single" collapsible className="border-t border-[#D9D6CC]">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`f${i}`} className="border-b border-[#D9D6CC]" data-testid={`faq-${i}`}>
                <AccordionTrigger className="py-6 text-left font-heading text-[1.35rem] md:text-[1.55rem] leading-snug text-[#172B38] hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="pb-7 pr-8 text-[1rem] leading-relaxed text-[#3E474B]">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
